// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3_nyk","list":"BalanceDue_list__OkUMG","listRow":"BalanceDue_listRow__2Qysc","total":"BalanceDue_total__3bJW5"};